import { render, staticRenderFns } from "./SendTask.vue?vue&type=template&id=22febef9&scoped=true&"
import script from "./SendTask.vue?vue&type=script&lang=js&"
export * from "./SendTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22febef9",
  null
  
)

export default component.exports